<template>
  <UiCard class="text-start" body-padding="none" :classes="{ body: 'w-full' }" @click="onClick">
    <template #header>
      <div class="flex justify-between p-4 pb-5">
        <UiInfo
          has-image
          :subtitle="policy.policyNumberId?.replace('-', ')')"
          :classes="{
            wrapper: 'flex-col items-start gap-2 text-sm',
            titlesWrapper: 'items-start gap-0',
            image: 'size-8 border p-0',
          }"
          :image="policy.companyLogo"
        >
          <template #title>
            <p class="font-semibold">
              {{ policy.fundShortText?.toUpperCase() }}
              <UiIconCircleSeparator />
              {{ policy?.fundId }}
            </p>
          </template>
        </UiInfo>
        <PensionPortfolioPartialsRecommendationChip class="h-fit w-14" v-if="policy.recommendationId" />
      </div>
    </template>

    <div class="flex w-full flex-col gap-3 p-4 pt-0">
      <div class="flex justify-between text-sm" v-for="detail in policyDetails" :key="detail.label">
        <span class="font-light text-black/50">{{ detail.label }}</span>
        <span class="font-semibold">{{ detail.value }}</span>
      </div>
    </div>
  </UiCard>
</template>

<script setup lang="ts">
const props = defineProps<{ policy: MyPensionPortfolioPolicy; onClick: () => void }>()
const { policy } = toRefs(props)

const textHelpers = usePensionPortfolioTextHelpers()

const policyDetails = computed(() => {
  return [
    { label: "חיסכון נוכחי", value: textHelpers.toExistsWithCash(policy.value?.currentSavings) },
    { label: "תאריך הצטרפות", value: textHelpers.formatDate(policy.value?.joinDate) },
    { label: "סטטוס", value: textHelpers.toStatus(policy.value?.status) },
    {
      label: "מעמד",
      value: textHelpers.toExists(textHelpers.extractFrom(PosStandTitles, policy.value?.posStand), true),
    },
  ]
})
</script>
